import AnimatedHeading from "components/animated-heading";
import AnimationContainer from "components/animation-container";
import { graphql, StaticQuery } from "gatsby";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import styled, { keyframes } from "styled-components";
import ContactPersonalForm from "./parts/ContactPersonalForm";

const Section = styled.section`
  position: relative;
  overflow: hidden;
  background-color: #000;
  padding: 100px 0;
`;

const FormRow = styled(Row)`
  background-color: #111;
`;

const ContactCol = styled(Col)`
  min-height: 600px;
  max-height: 600px;
  padding: 0;
  display: flex;
  align-items: center;
`;

const gradientAnimation = keyframes`
        0% {
            background-position: 15% 0%;
        }
        50% {
            background-position: 85% 100%;
        }
        100% {
            background-position: 15% 0%;
        }
    `;

const Gradient = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  clip-path: polygon(
    0% 100%,
    10px 100%,
    10px 10px,
    calc(100% - 10px) 10px,
    calc(100% - 10px) calc(100% - 10px),
    10px calc(100% - 10px),
    10px 100%,
    100% 100%,
    100% 0%,
    0% 0%
  );
  background: linear-gradient(
    120deg,
    #04e5e5,
    #f37055,
    #ef4e7b,
    #a166ab,
    #5073b8,
    #1098ad,
    #07b39b,
    #6fba82
  );
  background-size: 300% 300%;
  animation: ${gradientAnimation} 5s ease-in-out infinite;
`;

const Map = styled.iframe`
  filter: invert(100%);
  border: none;
  height: 100%;
  width: 100%;
`;

const IconRow = styled(Row)`
  margin-top: 150px;
`;

const IconCol = styled(Col)`
  @media (max-width: 500px) {
    margin-bottom: 140px;
  }
`;

const IconContainer = styled.div`
  width: 150px;
  height: 150px;
  margin: auto;
  padding: 35px;
  text-align: center;
  position: relative;
  bottom: 75px;
  background: linear-gradient(
    120deg,
    #04e5e5,
    #f37055,
    #ef4e7b,
    #a166ab,
    #5073b8,
    #1098ad,
    #07b39b,
    #6fba82
  );
  background-size: 300% 300%;
  animation: ${gradientAnimation} 5s ease-in-out infinite;
  border-radius: 150px;
  transition: 0.5s;
`;

const InfoPart = styled.div`
  min-height: 250px;
  background-color: #111;
  border: 2px solid #444;
`;
const Icon = styled.img`
  height: 70px;
  width: 70px;
  object-fit: contain;
`;

const InfoTitle = styled.h4`
  font-size: 35px;
  color: #fff;
  font-family: Teko;
  text-align: center;
`;

const Info = styled.div`
  position: relative;
  bottom: 30px;
`;

const InfoLinkContainer = styled.div`
  text-align: center;
`;

const InfoLink = styled.a`
  color: #04e5e5;
  transition: 0.5s;
  &:hover {
    color: #fff;
    text-decoration: none;
  }
`;

const EmailPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 40px;
  background-color: #0a0a0a;
`;

const emailPulse = keyframes`
  0%, 100% { filter: drop-shadow(0 0 8px rgba(4, 229, 229, 0.3)); }
  50% { filter: drop-shadow(0 0 20px rgba(4, 229, 229, 0.7)); }
`;

const EmailIconWrapper = styled.div`
  width: 80px;
  height: 80px;
  margin-bottom: 25px;
  animation: ${emailPulse} 3s ease-in-out infinite;
  svg {
    width: 100%;
    height: 100%;
  }
`;

const EmailTitle = styled.h3`
  font-size: 40px;
  font-family: Teko;
  color: #fff;
  margin-bottom: 15px;
`;

const EmailText = styled.p`
  font-size: 14px;
  color: #888;
  text-align: center;
  max-width: 320px;
  line-height: 1.6;
  margin-bottom: 25px;
`;

const EmailAddress = styled.a`
  color: #04e5e5;
  font-size: 18px;
  font-family: 'Courier New', monospace;
  letter-spacing: 1px;
  text-decoration: none;
  padding: 10px 25px;
  border: 1px solid rgba(4, 229, 229, 0.3);
  border-radius: 4px;
  transition: all 0.3s;
  &:hover {
    color: #fff;
    border-color: #04e5e5;
    box-shadow: 0 0 20px rgba(4, 229, 229, 0.3);
    text-decoration: none;
  }
`;

class ContactPersonal extends React.Component {
  render() {

    return (
      <Section id="contact">
        <Container>
          <AnimatedHeading text="Contact Me" />
          <AnimationContainer animation="fadeIn">
            <FormRow>
              <ContactCol md={6}>
                <ContactPersonalForm />
                <Gradient />
              </ContactCol>
              {/* Map temporarily removed
              <ContactCol md={6}>
                <Map
                  title="map"
                  src="https://www.google.com/maps/embed?..."
                />
              </ContactCol>
              */}
              <ContactCol md={6}>
                <EmailPanel>
                  <EmailIconWrapper>
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="2" y="4" width="20" height="16" rx="3" stroke="#04e5e5" strokeWidth="1.5" fill="none" />
                      <path d="M2 7l8.165 5.715a3 3 0 003.67 0L22 7" stroke="#04e5e5" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                  </EmailIconWrapper>
                  <EmailTitle>Direct Line</EmailTitle>
                  <EmailText>
                    Feel free to reach out for collaborations, opportunities, or just a friendly chat.
                  </EmailText>
                  <EmailAddress href="mailto:human2lkai@gmail.com">
                    human2lkai@gmail.com
                  </EmailAddress>
                </EmailPanel>
              </ContactCol>
            </FormRow>
          </AnimationContainer>
          {/* Phone, Email card, and Address cards temporarily removed
          <IconRow>
            <IconCol md={4}>
              <AnimationContainer animation="fadeIn" delay={500}>
                <InfoPart>
                  <IconContainer>
                    <Icon src={this.props.emailIcon.childImageSharp.fluid.src} alt="email" />
                  </IconContainer>
                  <Info>
                    <InfoTitle>Email</InfoTitle>
                    <InfoLinkContainer>
                      <InfoLink href="mailto:human2lkai@gmail.com">human2lkai@gmail.com</InfoLink>
                    </InfoLinkContainer>
                  </Info>
                </InfoPart>
              </AnimationContainer>
            </IconCol>
            <IconCol md={4}>
              <AnimationContainer animation="fadeIn" delay={1000}>
                <InfoPart>
                  <IconContainer>
                    <Icon src={this.props.phoneIcon.childImageSharp.fluid.src} alt="phone" />
                  </IconContainer>
                  <Info>
                    <InfoTitle>Phone</InfoTitle>
                    <InfoLinkContainer>
                      <InfoLink href="tel:+(61)0420-887-133">+(61)0420-887-133</InfoLink>
                    </InfoLinkContainer>
                  </Info>
                </InfoPart>
              </AnimationContainer>
            </IconCol>
            <IconCol md={4}>
              <AnimationContainer animation="fadeIn" delay={1500}>
                <InfoPart>
                  <IconContainer>
                    <Icon src={this.props.mapIcon.childImageSharp.fluid.src} alt="map" />
                  </IconContainer>
                  <Info>
                    <InfoTitle>Address</InfoTitle>
                    <InfoLinkContainer>
                      <InfoLink target="_blank" href="#" onClick={(event) => event.preventDefault()}>
                        7 Dayman Place, Marsfield NSW 2122
                      </InfoLink>
                    </InfoLinkContainer>
                  </Info>
                </InfoPart>
              </AnimationContainer>
            </IconCol>
          </IconRow>
          */}
        </Container>
      </Section>
    );
  }
}

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        emailIcon: file(relativePath: { eq: "icons/email2.png" }) {
          childImageSharp {
            fluid(maxWidth: 500) {
              src
            }
          }
        }
        mapIcon: file(relativePath: { eq: "icons/map.png" }) {
          childImageSharp {
            fluid(maxWidth: 500) {
              src
            }
          }
        }
        phoneIcon: file(relativePath: { eq: "icons/phone.png" }) {
          childImageSharp {
            fluid(maxWidth: 500) {
              src
            }
          }
        }
      }
    `}
    render={(data) => {
      if (!data || !data.emailIcon || !data.mapIcon || !data.phoneIcon) return null;
      return (
        <ContactPersonal
          emailIcon={data.emailIcon}
          mapIcon={data.mapIcon}
          phoneIcon={data.phoneIcon}
          {...props}
        />
      );
    }}
  />
);
